import React from "react";

export const TestiStory = () => {
  return (
    <div>
      <h1>Tell your Story</h1>
      <div>
        <div className="pf-quantity-element">
          <label
            className="pf-quantity-label resizeLabels"
            htmlFor="storyTitle"
          >
            <span>
              <b>Title Story*:</b>
            </span>
          </label>
          <input
            type="text"
            id="storyTitle"
            name="storyTitle"
            className="form-input field__input  resizeInputs"
            placeholder="Title Story"
            label="Title Story"
          />
        </div>
        <div style={{ marginTop: "2%" }}>
          <label className="form-label fs-body-base" htmlFor="storyBody">
            <i> Tell your Story Here*:</i>
          </label>
          <textarea
            label="Tell your Story Here"
            id="storyBody"
            name="storyBody"
            className="form-input form-input-placeholder textareaStory input "
            placeholder="Write your story as if you were writing to a friend."
          ></textarea>
        </div>
      </div>
      <br />
      <div>
        <h1>Vendor Team</h1>
        <div className="">
          <div className="pf-quantity-element">
            <label
              className="pf-quantity-label resizeLabels"
              htmlFor="dressDesigner"
            >
              <span>
                Dress Shop or Designer:
              </span>
            </label>
            <input
              type="text"
              id="dressDesigner"
              name="dressDesigner"
              className="form-input field__input  resizeInputs"
            ></input>
          </div>

          <div className="pf-quantity-element">
            <label
              className="pf-quantity-label resizeLabels"
              htmlFor="groomsAttire"
            >
              <span>
                Grooms Attire:
              </span>
            </label>
            <input
              type="text"
              id="groomsAttire"
              name="groomsAttire"
              className="form-input field__input  resizeInputs"
            />
          </div>

          <div className="pf-quantity-element">
            <label className="pf-quantity-label resizeLabels" htmlFor="band">
              <span>
                Dj or Band:
              </span>
            </label>
            <input
              type="text"
              id="band"
              name="band"
              className="form-input field__input  resizeInputs"
            ></input>
          </div>
          <div className="pf-quantity-element">
            <label className="pf-quantity-label resizeLabels" htmlFor="tentRentals">
              <span>
                Tent Rentals:
              </span>
            </label>
            <input
              type="text"
              id="tentRentals"
              name="tentRentals"
              className="form-input field__input  resizeInputs"
            ></input>
          </div>

          <div className="pf-quantity-element">
            <label className="pf-quantity-label resizeLabels" htmlFor="caterer">
              <span>
                Caterer:
              </span>
            </label>
            <input
              type="text"
              id="caterer"
              name="caterer"
              className="form-input field__input  resizeInputs"
            ></input>
          </div>

          <div className="pf-quantity-element">
            <label className="pf-quantity-label resizeLabels" htmlFor="rentals">
              <span>
                Rentals:
              </span>
            </label>
            <input
              type="text"
              id="rentals"
              name="rentals"
              className="form-input field__input  resizeInputs"
            ></input>
          </div>

          <div style={{ marginTop: "1%" }}>
            <textarea
              label="Other Vendors:"
              id="otherVendors"
              name="otherVendors"
              className="form-input form-input-placeholder textareaStory input textareaVendors input "
              placeholder="Other Vendors:"
            ></textarea>
          </div>
        </div>
      </div>
    </div>
  );
};
